import { render, staticRenderFns } from "./PointRedemption.vue?vue&type=template&id=b0de0c92&scoped=true"
import script from "./PointRedemption.vue?vue&type=script&lang=js"
export * from "./PointRedemption.vue?vue&type=script&lang=js"
import style0 from "./PointRedemption.vue?vue&type=style&index=0&id=b0de0c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0de0c92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VTextField})
